module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('main', [_c('v-content', [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "md6": "md6",
      "xs12": "xs12",
      "offset-md3": "true"
    }
  }, [_c('header', {
    staticClass: "display-3"
  }, [_vm._v(_vm._s(_vm.title) + "\n              "), _c('blockquote', {
    staticClass: "mb-4",
    staticStyle: {
      "border-left": "0px",
      "padding-left": "0rem"
    }
  }, [_c('v-icon', {
    staticClass: "display-1 primary--text pr-2",
    staticStyle: {
      "vertical-align": "bottom"
    }
  }, [_vm._v("people")]), _vm._v("\n                " + _vm._s(_vm.subtitle) + "\n              ")], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.error.timeout,
      "top": true
    },
    model: {
      value: (_vm.error.show),
      callback: function($$v) {
        _vm.error.show = $$v
      },
      expression: "error.show"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.error.message) + "\n                "), _c('v-btn', {
    staticClass: "blue--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.error.show = false
      }
    }
  }, [_vm._v("Chiudi")])], 1), _vm._v(" "), _vm._l((_vm.member.contact), function(m) {
    return _c('v-text-field', {
      key: m.label,
      attrs: {
        "label": m.label,
        "type": m.type
      },
      nativeOn: {
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.signUp($event)
        }
      },
      model: {
        value: (m.data),
        callback: function($$v) {
          m.data = $$v
        },
        expression: "m.data"
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.signUp($event)
      }
    }
  }, [_vm._v("Iscriviti")]), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }, [_vm._v("Hai già un account? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Login")])], 1)], 1)], 2)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25ee35a2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signup.vue
// module id = 119
// module chunks = 1